// extracted by mini-css-extract-plugin
export var categoryIcon = "_dx-5";
export var connectorContainer = "_dx-1";
export var connectorLine = "_dx-0";
export var minHeight0 = "_dx-6";
export var relativeUnitValueSelector = "_dx-2";
export var trifoldSelectorBody = "_dx-4";
export var trifoldSelectorList = "_dx-3";